import { render, staticRenderFns } from "./createNode.vue?vue&type=template&id=f8fe500a&scoped=true&"
import script from "./createNode.vue?vue&type=script&lang=js&"
export * from "./createNode.vue?vue&type=script&lang=js&"
import style0 from "./createNode.vue?vue&type=style&index=0&id=f8fe500a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fe500a",
  null
  
)

export default component.exports